var map = {
	"./1_kk.png": 5390,
	"./1_ru.png": 1127,
	"./2_kk.png": 9327,
	"./2_ru.png": 5538,
	"./3_kk.png": 1628,
	"./3_ru.png": 3777,
	"./4_kk.png": 8549,
	"./4_ru.png": 9876,
	"./5_kk.png": 1066,
	"./5_ru.png": 7371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5064;